import styled from 'styled-components'

export const ExpenseTypeTilesRowStyled = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`
